<template>
  <div>
    <el-button type="warning" size="small"  @click="dialogVisible = true">计算利息</el-button>
    <el-dialog :visible="dialogVisible" title="计算利息" width="800px" @close="closeDialog">
      <el-form :model="val" ref="form" :rules="rules" label-width="150px">
        <!-- <el-form-item label="币种：" prop="coinType">
          <el-select v-model="val.coinType">
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>  -->
        <el-form-item label="今日分发总数量：" prop="amount">
          <el-input-number v-model="val.amount" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Upload from "components/upload";

export default {
  name: "cornucopiaCreate",
  data() {
    return {
      dialogVisible: false,
      val: {},
      times: [],
      rules: {
        // coinType: {
        //   required: true,
        //   message: "请填写"
        // },
        amount: {
          required: true,
          message: "请填写"
        }
      }
    };
  },
  components: {
    Upload
  },
  computed: {
    ...mapState("mining", ["coinTypeList"])
  },
  methods: {
    ...mapActions("miningbonus", ["setcalculate"]),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.setcalculate({
        ...this.val
      }).then(() => {
        this.$message({
          message: "添加成功！",
          type: "success"
        });
        this.dialogVisible = false;
        this.$emit("refresh");
      });
    }
  }
};
</script>

<style lang="less">
</style>
